import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of } from 'rxjs'
import { withLatestFrom } from 'rxjs/operators'
import { withBlockingRequest } from '../Application/withBlockingRequest.js'
import { ProjectLockedBlockerId } from './HandleProjectLockChangedEpic.js'

export const ToggleDraftModeEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.toggleDraftModeRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      if (action.payload.draftMode) {
        return ProjectRepository.activateDraftMode(action.payload.projectId, { version: action.payload.version }).pipe(
          mergeMap(() => of(project.toggleDraftModeSuccess(action.payload))),
          catchError((error) => of(project.toggleDraftModeFailure({ error })))
        )
      } else {
        return withBlockingRequest(
          ProjectRepository.deactivateDraftMode(action.payload.projectId, { version: action.payload.version }).pipe(
            mergeMap(() => of(project.toggleDraftModeSuccess(action.payload))),
            catchError((error) => of(project.toggleDraftModeFailure({ error })))
          ),
          'Updating Evaluation Data',
          'Please wait, this may take a few minutes for large projects',
          ProjectLockedBlockerId(action.payload.projectId)
        )
      }
    })
  )
